<!-- Make sure to include Font Awesome CSS in your project for icons -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">

<div class="container mt-4">
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-ruler mr-2"></i> Mô tả Vật lý
  </h1>

  <!-- Description Below Title -->
  <p class="lead mb-4">
    Xem và quản lý các thuộc tính vật lý của mục. Phần này cung cấp thông tin chi tiết về kích thước, trọng lượng, số trang và loại bìa. Đảm bảo tất cả các mô tả vật lý đều chính xác để tạo điều kiện thuận lợi cho việc phân loại và xử lý.
  </p>

  <!-- Physical Description Table -->
  <div class="card shadow mb-4">
    <div class="card-body">
      <div class="table-responsive">
        <div *ngIf="loadingIndicator; else loaded">
          <app-loading></app-loading>
        </div>

        <ng-template #loaded>

          <button class="btn btn-outline-primary btn-icon-split mb-3" (click)="openAddDialog()">
            <span class="icon text-white-50">
              <i class="fas fa-plus"></i>
            </span>
            <span class="text">Thêm Mô tả Vật lý</span>
          </button>


          <button class="btn btn-outline-info btn-icon-split mb-3" (click)="refreshData()">
            <span class="icon text-white-50">
              <i class="fas fa-sync-alt"></i>
            </span>
            <span class="text">Làm mới</span>
          </button>

          <!-- Button trigger modal -->
         

          <div>
            <input
              type="text"
              class="form-control"
              placeholder="Tìm kiếm theo thuộc tính..."
              (input)="updateFilter($event)"
            />
          </div>

          <ngx-datatable
            class="bootstrap"
            [rows]="descriptions"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10"
            [loadingIndicator]="loadingIndicator"
            [reorderable]="reorderable"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
          >
           <!-- Binding Type -->
           <ngx-datatable-column name="Loại Bìa" [prop]="'bindingType'">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span style="color: red;">
                {{ row.bindingType }}
              </span>
            </ng-template>
          </ngx-datatable-column>


            <!-- Height -->
            <ngx-datatable-column name="Chiều cao (cm)" [prop]="'height'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.height }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Width -->
            <ngx-datatable-column name="Chiều rộng (cm)" [prop]="'width'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.width }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Thickness -->
            <ngx-datatable-column name="Độ dày (cm)" [prop]="'thickness'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.thickness }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Weight -->
            <ngx-datatable-column name="Trọng lượng (g)" [prop]="'weight'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.weight }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Page Count -->
            <ngx-datatable-column name="Số trang" [prop]="'pageCount'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.pageCount }}
              </ng-template>
            </ngx-datatable-column>

           

            <!-- Actions -->
            <ngx-datatable-column name="Hành động">
              <ng-template ngx-datatable-cell-template let-row="row">
              <!--   <button class="btn btn-sm btn-outline-primary" (click)="openEditDialog(row)" title="Chỉnh sửa">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" (click)="deleteRow(row)" title="Xóa">
                  <i class="fas fa-trash"></i>
                </button> -->
                
                  <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="actionDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    Hành động
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="actionDropdown">
                    <li>
                      <a class="dropdown-item"  (click)="openEditDialog(row)">
                        <i class="fas fa-edit text-primary"></i> Chỉnh sửa
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item"  (click)="deleteRow(row)">
                        <i class="fas fa-trash text-danger"></i> Xóa
                      </a>
                    </li>
                  </ul>
                
                
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
</div>
